import { useNavigate, useParams } from 'react-router-dom';
import { FinishedGoodsProductionModal } from '../../components/inventory/FinishedGoodsProductionModal';

/** Scan target for a Finished Good QR label: opens the production modal read-only. */
export const FinishedGoodViewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const close = () => navigate('/inventory');

  return (
    <FinishedGoodsProductionModal
      isOpen
      mode="view"
      productionId={id}
      onClose={close}
      onSuccess={() => {
        /* read-only view: nothing to persist */
      }}
    />
  );
};
